import DatePicker from "react-datepicker";

import "./DatePicker.module.scss";
export default DatePicker;
